import { Component, h, render } from "preact";

import $ from "jquery";
import { PRODUCT_UID_ATTR } from "@/constants/selectors";
import Stars from "@/components/ProductRating/ProductRating";
import { boundActions } from "@store/actions";
import { getProducts } from "@api/index";

export async function initBlock756() {
  // 1. Найти все элементы

  /**
   * @type {Object<string, JQuery<HTMLElement>>}
   */
  const productsJqElementsById = {};
  const productsJqElements = $('[data-record-type="756"], .t756');

  // 2. Сформировать массив данных

  /**
   * @constant Массив товаров
   * @type {Product[]}
   */
  const productsArray = productsJqElements.toArray().map((productCard) => {
    const productCardJqElement = $(productCard);

    const productInfo = {
      uid: productCardJqElement
        .find(`[${PRODUCT_UID_ATTR}]`)
        .attr(PRODUCT_UID_ATTR),
      image: productCardJqElement.find(".t-slds__bgimg").attr("data-original"),
      name: productCardJqElement.find(".t756__title").text(),
      price: Number.parseFloat(
        productCardJqElement.find(".t756__price-value").first().text()
      ),
    };

    productsJqElementsById[productInfo.uid] = productCardJqElement;

    return productInfo;
  });

  const productsIds = productsArray.map((p) => p.uid);

  // 3. Получить данные с сервера
  try {
    const productsData = await getProducts(productsIds);

    // Сохраняю все дело в стейте
    boundActions.setProducts(
      productsData.reduce((acc, val) => {
        return { ...acc, [val.uid]: val };
      }, {})
    );

    for (let i = 0; i < productsIds.length; i++) {
      const id = productsIds[i];
      const productJqElement = productsJqElementsById[id];

      // 3. Встраивание элементов плагина

      // Индикатор рейтинга в карточке товара
      productJqElement.find(".__CC-inject").remove();
      const starsMiniEl = document.createElement("div");
      starsMiniEl.classList.add("__CC-inject");
      // starsMiniEl.style.display = "flex";
      // starsMiniEl.style.justifyContent = "center";
      productJqElement.find(".t756__title").before(starsMiniEl);
      render(<Stars productUid={id} />, starsMiniEl);
    }
  } catch (e) {
    console.error("Ошибка при загрузке товаров", e);
  }
}
